import React, { useEffect, useRef } from 'react';

const IdleTimeout = ({ timeout, onLogout }) => {
  // Create a ref to persist timeoutId across renders
  const timeoutIdRef = useRef(null);

  // Reset timeout (this function will clear the previous timeout and set a new one)
  const resetTimeout = () => {
    // Clear the existing timeout if there's one
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
    }

    // Debugging log to show when the timeout is reset
    //console.log('Timeout reset due to user activity');

    // Set a new timeout to call onLogout after the specified timeout period (in ms)
    timeoutIdRef.current = setTimeout(() => {
      // When timeout finishes, call onLogout
      //console.log('Timeout reached, calling onLogout');
      onLogout();
    }, timeout * 1);  // Convert seconds to milliseconds
  };

  // Handle user activity (reset timeout)
  const handleUserActivity = () => {
    //console.log('User activity detected: resetting timeout');
    resetTimeout();
  };

  // UseEffect to set up event listeners when the component mounts
  useEffect(() => {
    //console.log('Setting up event listeners for user activity');
    //console.log(timeout);
    // Initialize timeout on first load
    resetTimeout();

    // Add event listeners for mouse move and key down
    document.addEventListener('mousemove', handleUserActivity);
    document.addEventListener('keydown', handleUserActivity);

    // Cleanup function to remove event listeners and clear timeout
    return () => {
      //console.log('Cleaning up, removing event listeners and clearing timeout');
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }

      document.removeEventListener('mousemove', handleUserActivity);
      document.removeEventListener('keydown', handleUserActivity);
    };
  }, [timeout]);  // Dependency array ensures this effect is triggered on timeout change

  return null; // This component doesn't render anything to the UI
};

export default IdleTimeout;
